// src/lib/supabase.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (import.meta.env.PROD && import.meta.env.VITE_MOCK_MODE === 'true') {
    throw new Error('VITE_MOCK_MODE must be false in production builds.');
}

export const isMockMode =
    import.meta.env.VITE_MOCK_MODE === 'true' || !supabaseUrl || !supabaseAnonKey;

export const supabase =
    isMockMode || !supabaseUrl || !supabaseAnonKey
        ? null
        : createClient(supabaseUrl, supabaseAnonKey, {
            auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true },
            global: {
                headers: {
                    apikey: supabaseAnonKey,
                },
            },
        });

export const buildSupabaseHeaders = (accessToken?: string) => {
    const headers: Record<string, string> = {};
    if (supabaseAnonKey) headers['apikey'] = supabaseAnonKey;
    // Only set Authorization when we have a real user token — never fall back to
    // the anon key, which is not a valid user JWT and will cause 401s on
    // authenticated Edge Functions.
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
    return headers;
};

export const anonKey = supabaseAnonKey;
